import React, { createContext, useEffect, useState } from "react"
import { AES, enc } from "crypto-js"
import useAxios from "../hooks/useAxios"
import { config, defaultAuthConfig } from './config'
import useLocalStorage from "../hooks/useLocalStorage"
import { profilesEndPoints } from "./endpoints"
import { format } from "react-string-format"
const Context = createContext()
function ContextProvider(props) {
    const { getAppItem, setAppItem, clearAll } = useLocalStorage()
    const { axios } = useAxios()
    const storedAppData = getAppItem("appData", "")
    const defaultAuthObj = storedAppData !== "" ? JSON.parse(AES.decrypt(storedAppData, config.APP_SECRET).toString(enc.Utf8)) : defaultAuthConfig
    const [authData, setAuthData] = useState(defaultAuthObj)
    const [permissions, setPermissions] = useState([])
    const resetAuth = () => {
        setAuthData(defaultAuthConfig)
        setPermissions([])
        clearAll()
    }
    useEffect(() => {
        if (authData.exp) {
            setAppItem("appData", AES.encrypt(JSON.stringify(authData), config.APP_SECRET).toString())
            let url = format(profilesEndPoints.getProfilePermissionsListById, authData.context.id_profile)
            axios.get(url,
                { headers: { 'Authorization': `Bearer ${authData.token}` } })
                .then(res => {
                    if (res.data.success) {
                        const { data } = res.data
                        setPermissions(data)
                    }
                })
                .catch(err => console.error(err))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authData])
    return (
        <Context.Provider value={
            {
                axios,
                authData,
                permissions,
                setPermissions,
                setAuthData,
                resetAuth
            }
        }>
            {props.children}
        </Context.Provider>
    )
}

export { ContextProvider, Context }